"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionReoccurence = exports.SubscriptionGate = exports.PasswordGate = exports.LoginGate = exports.GDPR = exports.TheaterMode = exports.IFrameMessageSource = exports.InternalMaestroSDKEvents = exports.InternalMaestroMessages = exports.MessagesFromMaestroWeb = exports.EventType = void 0;
var EventType;
exports.EventType = EventType;

(function (EventType) {
  EventType["REQUEST_LOGIN"] = "request:login";
  EventType["REQUEST_LOGOUT"] = "request:logout";
  EventType["SUBSCRIPTION_REQUIRED"] = "subscription:required";
  EventType["MAESTRO_READY"] = "maestro:ready";
  EventType["LOCALE_CHANGE"] = "locale:change";
  EventType["CHANNEL_CHANGE"] = "channel:change";
})(EventType || (exports.EventType = EventType = {}));

var MessagesFromMaestroWeb;
exports.MessagesFromMaestroWeb = MessagesFromMaestroWeb;

(function (MessagesFromMaestroWeb) {
  MessagesFromMaestroWeb["RETURN_ACCOUNT"] = "return:account";
  MessagesFromMaestroWeb["LOGIN_COMPLETE"] = "login:complete";
  MessagesFromMaestroWeb["ACCOUNT_SET"] = "account:set";
  MessagesFromMaestroWeb["LOGOUT_COMPLETE"] = "logout:complete";
})(MessagesFromMaestroWeb || (exports.MessagesFromMaestroWeb = MessagesFromMaestroWeb = {}));

var InternalMaestroMessages;
exports.InternalMaestroMessages = InternalMaestroMessages;

(function (InternalMaestroMessages) {
  InternalMaestroMessages["INIT_LOCALE"] = "init:locale";
  InternalMaestroMessages["REQUEST_LAYOUT"] = "request:layout";
  InternalMaestroMessages["GET_MAESTRO_ACCOUNT"] = "get:maestro:account";
})(InternalMaestroMessages || (exports.InternalMaestroMessages = InternalMaestroMessages = {}));

var InternalMaestroSDKEvents;
exports.InternalMaestroSDKEvents = InternalMaestroSDKEvents;

(function (InternalMaestroSDKEvents) {
  InternalMaestroSDKEvents["ACCOUNT_RETURNED"] = "account:returned";
  InternalMaestroSDKEvents["LOGIN_COMPLETE"] = "login:complete";
  InternalMaestroSDKEvents["LOGOUT_COPLETE"] = "logout:complete";
})(InternalMaestroSDKEvents || (exports.InternalMaestroSDKEvents = InternalMaestroSDKEvents = {}));

var IFrameMessageSource;
exports.IFrameMessageSource = IFrameMessageSource;

(function (IFrameMessageSource) {
  IFrameMessageSource["IFRAME_SDK"] = "maestro:iframe:sdk:v1";
})(IFrameMessageSource || (exports.IFrameMessageSource = IFrameMessageSource = {}));

var TheaterMode;
exports.TheaterMode = TheaterMode;

(function (TheaterMode) {
  TheaterMode[TheaterMode["ENABLED"] = 1] = "ENABLED";
  TheaterMode[TheaterMode["DISABLED"] = 0] = "DISABLED";
})(TheaterMode || (exports.TheaterMode = TheaterMode = {}));

var GDPR;
exports.GDPR = GDPR;

(function (GDPR) {
  GDPR[GDPR["ENABLED"] = 1] = "ENABLED";
  GDPR[GDPR["DISABLED"] = 0] = "DISABLED";
})(GDPR || (exports.GDPR = GDPR = {}));

var LoginGate;
exports.LoginGate = LoginGate;

(function (LoginGate) {
  LoginGate[LoginGate["ENABLED"] = 1] = "ENABLED";
  LoginGate[LoginGate["DISABLED"] = 0] = "DISABLED";
})(LoginGate || (exports.LoginGate = LoginGate = {}));

var PasswordGate;
exports.PasswordGate = PasswordGate;

(function (PasswordGate) {
  PasswordGate[PasswordGate["ENABLED"] = 1] = "ENABLED";
  PasswordGate[PasswordGate["DISABLED"] = 0] = "DISABLED";
})(PasswordGate || (exports.PasswordGate = PasswordGate = {}));

var SubscriptionGate;
exports.SubscriptionGate = SubscriptionGate;

(function (SubscriptionGate) {
  SubscriptionGate[SubscriptionGate["ENABLED"] = 1] = "ENABLED";
  SubscriptionGate[SubscriptionGate["DISABLED"] = 0] = "DISABLED";
})(SubscriptionGate || (exports.SubscriptionGate = SubscriptionGate = {}));

var RoleScope;

(function (RoleScope) {
  RoleScope["SiteAdmin"] = "*";
  RoleScope["ChatModerator"] = "Chat_Moderator";
  RoleScope["Page"] = "Page";
  RoleScope["Quest"] = "Quest";
})(RoleScope || (RoleScope = {}));

var SubscriptionReoccurence;
exports.SubscriptionReoccurence = SubscriptionReoccurence;

(function (SubscriptionReoccurence) {
  SubscriptionReoccurence["once"] = "once";
  SubscriptionReoccurence["month"] = "month";
  SubscriptionReoccurence["year"] = "year";
})(SubscriptionReoccurence || (exports.SubscriptionReoccurence = SubscriptionReoccurence = {}));